var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1014",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1015"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1016"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00607d",
    d: "M393.6,433.7c0-5.6-1.9-10.3-5.6-14s-8.4-5.6-14-5.6s-10.3,1.9-14,5.6s-5.6,8.4-5.6,14 s1.9,10.3,5.6,14c3.7,3.7,8.4,5.6,14,5.6s10.3-1.9,14-5.6C391.7,443.9,393.6,439.3,393.6,433.7z M472.8,433.7 c0-5.6-1.9-10.3-5.6-14s-8.4-5.6-14-5.6s-10.3,1.9-14,5.6c-4.7,4.7-6.5,9.3-6.5,14c0,5.6,1.9,10.3,5.6,14s8.4,5.6,14,5.6 s10.3-1.9,14-5.6C471,443.9,472.8,439.3,472.8,433.7z M512,364.6v98.9c0,8.4-2.8,14.9-8.4,20.5s-13.1,8.4-20.5,8.4H28.9 c-8.4,0-14.9-2.8-20.5-8.4S0,471,0,463.5v-98.9c0-8.4,2.8-14.9,8.4-20.5c5.6-5.6,13.1-8.4,20.5-8.4h142.7l42,42 c12.1,11.2,26.1,17.7,42,17.7s29.8-5.6,42-17.7l42-42h142.7c8.4,0,14.9,2.8,20.5,8.4C509.2,349.7,512,357.2,512,364.6z  M412.2,189.3c3.7,8.4,1.9,15.9-4.7,21.4l-138,138c-3.7,3.7-8.4,5.6-14,5.6s-10.3-1.9-14-5.6l-138-138c-6.5-5.6-7.5-13.1-4.7-21.4 c3.7-8.4,9.3-12.1,18.7-12.1h79.3v-138c0-5.6,1.9-10.3,5.6-14c3.7-3.7,8.4-5.6,14-5.6h79.3c5.6,0,10.3,1.9,14,5.6s5.6,8.4,5.6,14 v138h79.3C402,177.2,408.5,181.9,412.2,189.3z",
    className: "color333 svgShape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f14c820aff7c628061f8038ae2672c7d.svg";
export { ForwardRef as ReactComponent };